import React, { useContext, useEffect, useRef } from 'react'
import styles from './styles.module.css'
import { Input } from '../../../components/ModalInputs'
import CustomSelect from '../../../components/CustomSelect'
import { streams } from '../../../assets/const'
import Button from '../../../components/Button'
import { StudentsContext } from '../../../utils/context'
import { useDispatch, useSelector } from 'react-redux'
import {
  getLibraryLanguages,
  getLibraryMilitaryDistricts,
  getLibraryResultIncluding,
  getLibrarySchools,
} from '../../../actions/library'

const examAdmissionStatuses = [
  { name: '', value: '' },
  { name: 'допущен', value: 'допущен' },
  { name: 'допущена', value: 'допущена' },
  { name: 'отказ', value: 'отказ' },
  { name: 'без экзаменов', value: 'без экзаменов' },
]

export default function Admission() {
  const dispatch = useDispatch()

  const { allForms, addMode, studentTabData, updateInitialValues } = useContext(StudentsContext)
  const { languages, militaryDistricts, resultIncluding, schools } = useSelector(state => state.library)

  const { values, setFieldValue, setValues } = allForms

  const { admission } = studentTabData || {}

  // Ref для отслеживания последних загруженных данных
  const lastSyncedAdmissionRef = useRef(null)

  // Кастомный handleChange для вложенных полей
  const handleAdmissionChange = (e) => {
    const { name, value, type, checked } = e.target
    setFieldValue(`admission.${name}`, type === 'checkbox' ? checked : value)
  }

  // Обёртка setFieldValue для CustomSelect
  const handleSelectChange = (name, value) => {
    setFieldValue(`admission.${name}`, value)
  }

  // Синхронизация формы с данными из API
  useEffect(() => {
    const admissionJson = JSON.stringify(admission)
    if (!addMode && admission && lastSyncedAdmissionRef.current !== admissionJson) {
      lastSyncedAdmissionRef.current = admissionJson
      setValues(prev => ({
        ...prev,
        admission: { ...admission }
      }))
      // Сохраняем начальные значения для отслеживания изменений
      if (updateInitialValues) {
        updateInitialValues('admission', admission)
      }
    }
  }, [admission, addMode, setValues, updateInitialValues])

  useEffect(() => {
    dispatch(getLibraryLanguages())
    if (!militaryDistricts?.length) dispatch(getLibraryMilitaryDistricts())
    if (!resultIncluding?.length) dispatch(getLibraryResultIncluding())
    if (!schools?.length) dispatch(getLibrarySchools())
  }, []) // eslint-disable-line

  return (
    <div className={styles.tabWrapper}>
      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Зачисление</h3>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Военный округ прибытия'
            valuesName='militarydistrictarrival'
            value={(values.admission || {}).militarydistrictarrival || ''}
            setFieldValue={handleSelectChange}
            options={(militaryDistricts || []).map(d => ({ name: d.name, value: d.name }))}
            withoutAll
            highlight
          />
          <CustomSelect
            title='Результат зачисления'
            valuesName='resultincluding'
            value={(values.admission || {}).resultincluding || ''}
            setFieldValue={handleSelectChange}
            options={(resultIncluding || []).map(r => ({ name: r.name || r, value: r.name || r }))}
            withoutAll
            highlight
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Допуск к экзаменам'
            valuesName='accesstoexam'
            value={(values.admission || {}).accesstoexam || ''}
            setFieldValue={handleSelectChange}
            options={examAdmissionStatuses}
            withoutAll
            highlight
          />
          <Input
            label='Причина отказа в допуске'
            name='reasondeny'
            onChange={handleAdmissionChange}
            value={(values.admission || {}).reasondeny || ''}
          />
        </div>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Вступительные экзамены</h3>
        <div className={styles.inputsRow}>
          <Input
            label='Экзамен 1'
            highlight
            name='enterexam1name'
            value={(values.admission || {}).enterexam1name || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка'
            highlight
            style={{ width: '50px' }}
            name='enterexam1grade'
            value={(values.admission || {}).enterexam1grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Экзамен 4'
            name='enterexam4name'
            value={(values.admission || {}).enterexam4name || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка'
            style={{ width: '50px' }}
            name='enterexam4grade'
            value={(values.admission || {}).enterexam4grade || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Экзамен 2'
            highlight
            name='enterexam2name'
            value={(values.admission || {}).enterexam2name || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка'
            highlight
            style={{ width: '50px' }}
            name='enterexam2grade'
            value={(values.admission || {}).enterexam2grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Экзамен 5'
            name='enterexam5name'
            value={(values.admission || {}).enterexam5name || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка'
            style={{ width: '50px' }}
            name='enterexam5grade'
            value={(values.admission || {}).enterexam5grade || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Экзамен 3'
            highlight
            name='enterexam3name'
            value={(values.admission || {}).enterexam3name || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка'
            highlight
            style={{ width: '50px' }}
            name='enterexam3grade'
            value={(values.admission || {}).enterexam3grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Экзамен 6'
            name='enterexam6name'
            value={(values.admission || {}).enterexam6name || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка'
            style={{ width: '50px' }}
            name='enterexam6grade'
            value={(values.admission || {}).enterexam6grade || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Психологический тест 1'
            highlight
            name='entertest1grade'
            value={(values.admission || {}).entertest1grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Психологический тест 2'
            highlight
            name='entertest2grade'
            value={(values.admission || {}).entertest2grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Психологический тест 3'
            highlight
            name='entertest3grade'
            value={(values.admission || {}).entertest3grade || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Психологический тест 4'
            name='entertest4grade'
            value={(values.admission || {}).entertest4grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Психологический тест 5'
            name='entertest5grade'
            value={(values.admission || {}).entertest5grade || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Психологический тест 6'
            name='entertest6grade'
            value={(values.admission || {}).entertest6grade || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            label='Суммарный балл за экзамены'
            name='exam_grades_sum'
            value={(values.admission || {}).exam_grades_sum || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Средний балл за экзамены'
            name='exam_grades_avg'
            value={(values.admission || {}).exam_grades_avg || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <p>Суммарный балл за экзамены: {(values.admission || {}).exam_grades_sum || 'null'},      включая псих.тесты: {(values.admission || {}).all_exam_grades_sum || 'null'}</p>
        <p>Средний балл за экзамены: {(values.admission || {}).exam_grades_avg || 'null'},      включая псих.тесты: {(values.admission || {}).all_exam_grades_avg || 'null'}</p>
      </div>

      <div className={styles.qualificationForm}>
        <h3 className={styles.sectionTitle}>Прочее</h3>
        <div className={styles.inputsRow}>
          <Input
            label='Ср. балл на момент пост.'
            highlight
            name='enteravggrade'
            value={(values.admission || {}).enteravggrade || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <Input
            style={{ width: '500px' }}
            label='Портфолио'
            name='portfoliotext'
            value={(values.admission || {}).portfoliotext || ''}
            onChange={handleAdmissionChange}
          />
          <Input
            label='Оценка портфолио'
            name='portfoliograde'
            value={(values.admission || {}).portfoliograde || ''}
            onChange={handleAdmissionChange}
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Училище для поступления'
            valuesName='idschool'
            value={(values.admission || {}).idschool || ''}
            setFieldValue={handleSelectChange}
            options={(schools || []).map(s => ({ name: s.name, value: s.id || s.xp_key }))}
            withoutAll
            highlight
          />
          <CustomSelect
            title='Набор'
            valuesName='stream'
            value={(values.admission || {}).stream !== undefined ? (values.admission || {}).stream : ''}
            setFieldValue={handleSelectChange}
            options={streams}
            withoutAll
          />
        </div>
        <div className={styles.inputsRow}>
          <CustomSelect
            title='Иностранные языки'
            width={500}
            valuesName='languages_title'
            value={(values.admission || {}).languages_title || ''}
            setFieldValue={handleSelectChange}
            options={languages?.map(el => ({ name: el.course_name, value: el.course_name })) || []}
            withoutAll
            placeholder="Выберите язык"
            dropUp
          />
          <Button style={{ alignSelf: 'flex-end' }}>Добавить</Button>
        </div>
      </div>
    </div>
  )
}
